'use client';

import React from 'react';

const HamburgerButton = (props: {
  ariaControlsId?: string;
  ariaLabel?: string;
  children: React.ReactNode;
  isExpanded: boolean;
  onClick: () => void;
}) => {
  const {
    ariaControlsId = 'navbar-menu',
    ariaLabel = 'Toggle navigation menu',
    children,
    isExpanded,
    onClick,
  } = props;

  return (
    <button
      type="button"
      className="hamburger"
      aria-label={ariaLabel}
      aria-controls={ariaControlsId}
      aria-expanded={isExpanded}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default HamburgerButton;
